var map = {
	"./costume_1.jpg": "./src/assets/default-costumes/costume_1.jpg",
	"./costume_10.jpg": "./src/assets/default-costumes/costume_10.jpg",
	"./costume_11.jpg": "./src/assets/default-costumes/costume_11.jpg",
	"./costume_12.jpg": "./src/assets/default-costumes/costume_12.jpg",
	"./costume_13.jpg": "./src/assets/default-costumes/costume_13.jpg",
	"./costume_14.jpg": "./src/assets/default-costumes/costume_14.jpg",
	"./costume_15.jpg": "./src/assets/default-costumes/costume_15.jpg",
	"./costume_16.jpg": "./src/assets/default-costumes/costume_16.jpg",
	"./costume_17.jpg": "./src/assets/default-costumes/costume_17.jpg",
	"./costume_18.jpg": "./src/assets/default-costumes/costume_18.jpg",
	"./costume_19.jpg": "./src/assets/default-costumes/costume_19.jpg",
	"./costume_2.jpg": "./src/assets/default-costumes/costume_2.jpg",
	"./costume_20.jpg": "./src/assets/default-costumes/costume_20.jpg",
	"./costume_3.jpg": "./src/assets/default-costumes/costume_3.jpg",
	"./costume_4.jpg": "./src/assets/default-costumes/costume_4.jpg",
	"./costume_5.jpg": "./src/assets/default-costumes/costume_5.jpg",
	"./costume_6.jpg": "./src/assets/default-costumes/costume_6.jpg",
	"./costume_7.jpg": "./src/assets/default-costumes/costume_7.jpg",
	"./costume_8.jpg": "./src/assets/default-costumes/costume_8.jpg",
	"./costume_9.jpg": "./src/assets/default-costumes/costume_9.jpg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/default-costumes sync \\.(jpg|jpeg|png|webp)$";